function cov_v97ueqzdb() {
  var path = "/app/src/components/learn-more-how-it-works/index.ts";
  var hash = "b789c796312c070ee915bd9c17778b1f4f8f7b63";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/learn-more-how-it-works/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b789c796312c070ee915bd9c17778b1f4f8f7b63"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_v97ueqzdb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_v97ueqzdb();
export { LearnMoreHowItWorks } from './learn-more-how-it-works';